/**
 * Cross-fading image gallery.
 *
 * data-gallery           the gallery container
 * data-gallery-slide     a single slide inside the gallery
 * data-gallery-interval  time between two slides in ms (default 5000)
 *
 * The first slide is rendered eagerly by PHP (in random order), the remaining
 * ones are shuffled here so the sequence differs on every visit. Slides whose
 * image has not been loaded yet are skipped instead of fading in empty.
 */

const shuffle = (items) =>
  items
    .map((item) => ({ item, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ item }) => item)

const isLoaded = (slide) => {
  const image = slide.querySelector('img')

  return !image || (image.complete && image.naturalWidth > 0)
}

// Tell lazysizes to fetch this slide before it is shown
const preload = (slide) => slide.querySelector('img')?.classList.add('lazypreload')

document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  const [first, ...rest] = [...gallery.querySelectorAll('[data-gallery-slide]')]

  if (!first || !rest.length) return

  const slides = [first, ...shuffle(rest)]
  slides.forEach((slide, index) => slide.classList.toggle('is-active', index === 0))

  const interval = Number(gallery.dataset.galleryInterval) || 5000
  let current = 0

  const next = () => {
    for (let step = 1; step < slides.length; step++) {
      const candidate = (current + step) % slides.length

      if (!isLoaded(slides[candidate])) {
        preload(slides[candidate])
        continue
      }

      slides[current].classList.remove('is-active')
      slides[candidate].classList.add('is-active')
      current = candidate
      break
    }

    preload(slides[(current + 1) % slides.length])
  }

  preload(slides[1])
  window.setInterval(next, interval)
})
